import _ from "lodash";
import intl from "react-intl-universal";

import httpService from "../_utils/http-service";
import * as types from "./types";
import { sortRestaurants } from "../_utils/sort-restaurants";
import { LIMIT } from "../_utils/constants";
import { getHttpConfig, getAuthHttpConfig } from "../_utils/auth-utils";
import { traceEvent } from "../_utils/analytics-utils";

const filterRestaurantsByName = (restaurants, name) => {
  return _.filter(restaurants, item =>
    item.restaurantName.toLowerCase().startsWith(name.toLowerCase())
  );
};

const filterRestaurants = (restaurants, filter) => {
  if (filter.cuisineTypeId.length !== 0) {
    restaurants = _.filter(restaurants, item => {
      let found = _.find(item.cuisineTypes, item => {
        return filter.cuisineTypeId.includes(item.id);
      });
      if (found !== undefined) {
        return true;
      }
      return false;
    });
  }

  if (filter.rating !== 0) {
    restaurants = _.filter(restaurants, item => item.rating > filter.rating);
  }

  return restaurants;
};

const isRestaurantOfferRewards = restaurant => {
  var found = _.find(
    restaurant.promoText,
    item => item.colorId === 1
  );
  return found !== undefined;
};

export const resetAll = () => {
  return function(dispatch) {
    dispatch({ type: types.REMOVE_ITEM, payload: "anonymousToken" });
    dispatch({ type: types.REMOVE_ITEM, payload: "customerName" });

    dispatch({ type: types.CLEAR_GROUP_ORDER_INFO });
    dispatch({ type: types.CLEAR_ORDER });

    dispatch({ type: types.SET_PAYING, payload: "" });
    dispatch({ type: types.CLEAR_SOCIAL_SIGNUP });
    dispatch({ type: types.COLLAPSE_CHECKOUT_ORDER_MODAL });
  };
};

export const searchRestaurants = (searchSettings, callback) => {
  return function(dispatch, getState) {
    traceEvent("restaurants", "search");

    if (searchSettings.currentLocation === null) {
      callback({ restaurants: [] });
      return;
    }

    const { latitude, longitude } = searchSettings.currentLocation;

    let url = `/v2/restaurants?serviceTypeId=1&longitude=${longitude}&latitude=${latitude}`;

    url = url + `&limit=${LIMIT}`;

    let httpConfig = getHttpConfig();

    const storage = getState().storage;

    if (storage.authToken !== undefined) {
      httpConfig = getAuthHttpConfig(storage);
    }

    httpService
      .get(url, httpConfig)
      .then(res => {
        if (res.data.statusCode === 200) {
          let restaurants = res.data.data;

          if (searchSettings.filter) {
            restaurants = filterRestaurants(restaurants, searchSettings.filter);
          }

          if (searchSettings.name !== "") {
            restaurants = filterRestaurantsByName(
              restaurants,
              searchSettings.name
            );
          }

          if (searchSettings.rewardsOnly === true) {
            restaurants = _.filter(restaurants, isRestaurantOfferRewards);
          }

          if (searchSettings.favoritesOnly === true) {
            let favorites = getState().storage.favorites;
            if (favorites === undefined) {
              favorites = [];
            }
            restaurants = _.filter(
              restaurants,
              item => favorites.includes(item.id) === true
            );
          }

          restaurants = sortRestaurants(restaurants, searchSettings.sort);

          _.map(restaurants, restaurant => {
            restaurant.latitude = restaurant.address.latitude;
            restaurant.longitude = restaurant.address.longitude;
          });

          callback({ restaurants });
        } else {
          traceEvent("error", "searchRestaurants");
          callback({ error: res.data.message });
        }
      })
      .catch(err => {
        traceEvent("error", "searchRestaurants");
        callback({ error: intl.get("general.serverError") });
      });
  };
};

export const setRestaurantsFound = restaurants => {
  return { type: types.RESTAURANTS_FOUND, payload: restaurants };
};

export const clearRestaurantsFound = () => {
  return { type: types.RESTAURANTS_CLEAR };
};
